import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function showAssessmentMethodDiv({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ assessmentMethodShow: true });
}

export function batchDelete({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.confirm({
      content: 'Do you want to delete these records?',
      okText: 'Delete',
      okType: 'danger',
      callback: function () {
        httpClient
          .post('Business/ApprovalPerformanceSolution/BatchDelete', sectionComponent.child.current?.state.selectedRowKeys)
          .then(({ data }) => {
            if (data.result) {
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              setTimeout(() => {
                sectionComponent.child.current?.getSectionDataByDefault();
              }, config.setTimeoutMilliSecond);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      }
    });
  } else {
    message.warning('You must select at least one performance solution.');
  }
}

export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  openAddFromTemplate({ component: pageComponent });
}

export function openAddFromTemplate({ component } = {}) {
  component.setState({ approvalPerformanceSolutionAddFromTemplateShow: true });
  component.approvalPerformanceSolutionAddFromTemplate.current?.setState({ activeKey: 0 });
  setTimeout(() => {
    component.approvalPerformanceSolutionAddFromTemplate.current?.formRef.current?.resetFields();
    component.approvalPerformanceSolutionAddFromTemplate.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], performanceSolutionTemplatePresetContentList: [] });
    setTimeout(() => {
      component.approvalPerformanceSolutionAddFromTemplate.current?.additionalFormRef.current?.child.current?.getPerformanceSolutionTemplateData();
      component.approvalPerformanceSolutionAddFromTemplate.current?.getPerformanceSolutionTemplatePresetDataSource();
      console.log(component.approvalPerformanceSolutionAddFromTemplate.current?.additionalFormRef.current?.child.current)
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

